import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Modal } from 'antd';
import { isMobile } from 'react-device-detect';
import BaseRadioList from '@/components/Elements/BaseRadios';
import { _newLine } from '@/utils/helpers';
import {
    createDocumentCategories,
    updateDocumentCategories
} from '@/redux/actions/documentCategorieActions';

class DocumentCategoryForm extends Component {
    state = { isSubmitting: false };

    submit = (event) => {
        event.preventDefault();
        this.props.form.validateFields(async (error, values) => {
            if (error) return;
            this.setState({ isSubmitting: true });
            try {
                if (this.props.currentItem) {
                    await this.props.updateDocumentCategories(this.props.currentItem.id, values);
                } else {
                    await this.props.createDocumentCategories(values);
                }
                this.close();
                this.props.reloadData();
            } catch (requestError) {
                this.setState({ isSubmitting: false });
            }
        });
    };

    close = () => {
        this.props.form.resetFields();
        this.setState({ isSubmitting: false });
        this.props.onCancel();
    };

    render() {
        const { visible, currentItem } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                visible={visible}
                title={currentItem ? 'Cập nhật danh mục văn bản' : 'Thêm danh mục văn bản'}
                maskClosable={false}
                width={isMobile ? '100%' : '45%'}
                onCancel={this.close}
                footer={[
                    <Button key="cancel" onClick={this.close}>Hủy</Button>,
                    <Button key="submit" type="primary" loading={this.state.isSubmitting} onClick={this.submit}>
                        {currentItem ? 'Cập nhật' : 'Thêm mới'}
                    </Button>
                ]}
            >
                {visible && (
                    <Form layout="vertical">
                        <Form.Item label="Tên danh mục">
                            {getFieldDecorator('name', {
                                initialValue: currentItem?.name || '',
                                rules: [
                                    { required: true, whitespace: true, message: 'Vui lòng nhập tên danh mục.' },
                                    { max: 255, message: 'Tên danh mục không được vượt quá 255 ký tự.' }
                                ]
                            })(<Input autoFocus />)}
                        </Form.Item>
                        <Form.Item label="Ghi chú">
                            {getFieldDecorator('note', {
                                initialValue: currentItem ? _newLine(currentItem.note) : ''
                            })(<Input.TextArea rows={4} />)}
                        </Form.Item>
                        <Form.Item label="Trạng thái">
                            {getFieldDecorator('status', {
                                initialValue: currentItem ? Number(currentItem.status) : 1,
                                rules: [{ required: true, message: 'Vui lòng chọn trạng thái.' }]
                            })(
                                <BaseRadioList options={[
                                    { label: 'Kích hoạt', value: 1 },
                                    { label: 'Ngừng sử dụng', value: 0 }
                                ]} />
                            )}
                        </Form.Item>
                    </Form>
                )}
            </Modal>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    createDocumentCategories: data => dispatch(createDocumentCategories(data)),
    updateDocumentCategories: (id, data) => dispatch(updateDocumentCategories(id, data))
});

export default connect(null, mapDispatchToProps)(
    Form.create({ name: 'documentCategoryForm' })(DocumentCategoryForm)
);
